import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
// import { useHistory } from "react-router";
import logo from "../../assets/img/Layer x0020 1.png";
import down from "../../assets/img/Profile/Wallet/Vector.png";
import Avatar from "../../assets/img/avatar.png";
import "./index.css";
// import seyi from "../../assets/img/Profile/Wallet/Ellipse 39.png"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import account from "../../assets/img/Vector.png";
import { getUser } from "../../services/auth";
import { removeState, removeStateWallet } from "../../store/removeState";
import newTag from "../../assets/img/new-flight.png";

export const Navbar = () => {
  const [user, setUser] = useState(null);
  // const [menu, setMenu] = useState(true);
  const [openCloseButton, setOpenCloseButton] = useState(false);
  const [isMenuActive, setIsMenuActive] = useState(0);
  const [isMenuActive2, setIsMenuActive2] = useState(0);
  const [isMenuActive3, setIsMenuActive3] = useState(0);
  // const [hamburger, setHamburger] = useState(0);

  // const setMenuBurger = ()=>{
  // setIsMenuActive(index)
  // let i
  // for(i=0; i<=4; i++){
  //     if(i===index) {
  //       setIsMenuActive(true)
  //     }else{
  //       setIsMenuActive(false)
  //     }
  // }
  // }

  // useEffect(()=>{
  // activeMenu(0)
  // })

  const toggleMenu = () => {
    // setMenu(false);
    setOpenCloseButton(!openCloseButton);
    var x = document.getElementById("navbarsExample09");
    if (x.style.display === "block") {
      x.style.display = "none";
    } else {
      x.style.display = "block";
    }
  };
  // const toggleMenu2 = () => {
  //   // setMenu(false);
  //   // alert("Clicked function")
  //   // var x = document.getElementById("sub-menu");
  //   var y = document.getElementById("sub-active");
  //   // var z = document.getElementById("sub-active-icon");
  //   // document.getElementById("myBtn").addEventListener("click", function() {
  //   //   alert("Hello World!");
  //   // });
  //   // y.classList.toggle("active");
  //   y.classList.toggle("active");
  //   // y.style.marginBottom = "50px";
  //   // if (x.style.display === "none") {
  //   // y.classList.remove("active");
  //   // x.style.display = "none";
  //   // x.style.transform = "translateY(-100)";
  //   // x.style.opacity = "0";
  //   // z.style.transform = "rotate(0deg)";
  //   //   y.style.marginBottom = "0px";
  //   // } else {
  //   // y.classList.toggle("active");
  //   //   x.style.display = "block";
  //   //   x.style.transform = "translateY(0)";
  //   //   x.style.opacity = "1";
  //   //   x.style.cursor = "pointer";
  //   //   x.style.zindex = "999";
  //   // z.style.transform = "rotate(-180deg)";
  //   // y.style.marginBottom = "50px";
  //   // }
  // };
  // const toggleMenu3 = () => {
  //   // setMenu(false);
  //   // var x = document.getElementById("sub-menu2");
  //   var y = document.getElementById("sub-active2");
  //   // var z = document.getElementById("sub-active-icon2");

  //   y.classList.toggle("active");
  // };
  // const toggleMenu4 = () => {
  //   // setMenu(false);
  //   // var x = document.getElementById("sub-menu3");
  //   var y = document.getElementById("sub-active3");
  //   // var z = document.getElementById("sub-active-icon2");

  //   y.classList.toggle("active");
  // };

  const history = useHistory();

  const userInfo = getUser();

  useEffect(() => {
    if (userInfo === null) {
      return false;
    } else {
      setUser(userInfo);
    }
    // eslint-disable-next-line
  }, []);

  const logOut = () => {
    removeState();
    removeStateWallet();
    history.push("/");
    window.location.reload();
  };

  return (
    <div className="navbar-section">
      <div className="container">
        <nav className="navb">
          <Link className="navbar-brand d-flex mr-auto" to="/">
            <img src={logo} alt="" className="home-logo" />
          </Link>
          <div
            // className="navbar-togg"
            className="navbar-togg"
            onClick={toggleMenu}
            // onClick={() => setMenuBurger(true)}
          >
            {openCloseButton ? (
              <i class="fa fa-times"></i>
            ) : (
              <i class="fa fa-bars"></i>
            )}
          </div>
          <div
            className=""
            id="navbarsExample09"
            style={{ paddingTop: "20px" }}
          >
            {user === null ? (
              <ul className="menu-links ml-auto justify-content-end align-items-center">
                {/* <a href="#home" >
                  <li className={`${isMenuActive === 0 ? "active" : ""}`}
                  onClick={() => activeMenu(0)}>Home</li>
                </a>
                <a href="#about">
                  <li>About</li>
                </a>
                <a href="#projects">
                  <li>Projects</li>
                </a>
                <a href="#services">
                  <li>Services</li>
                </a>
                <a href="#contact">
                  <li>Contact</li>
                </a>
                <i class="fa fa-times"></i>
                <div class="hamburger">
                  <i class="fa fa-bars"></i>
                </div> */}
                <li className="notify" style={{ marginLeft: "10px" }}>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://ghana.gigm.com/"
                    style={{ position: "relative", color: "black" }}
                  >
                    <img
                      src={newTag}
                      alt="nw-tag"
                      width="35"
                      height="35"
                      className="blink_me"
                      loading="lazy"
                      style={{
                        position: "absolute",
                        top: "-20px",
                        left: "30%",
                      }}
                    />
                    Ghana Booking
                  </a>
                </li>
                <li className="notify">
                  <button
                    id="sub-active"
                    // className="drop-down-option"
                    className={`${
                      isMenuActive === 0 ? "active" : "drop-down-option"
                    }`}
                    // onClick={toggleMenu2}
                  >
                    Move Freely
                    <img
                      id="sub-active-icon"
                      src={down}
                      alt=""
                      className="ml-1"
                    />{" "}
                  </button>
                  <ul className="submenu" id="sub-menu">
                    <li style={{ marginBottom: "10px" }}>
                      <Link to="/Pickupservice">Pick up Service</Link>
                    </li>
                    <li>
                      <Link to="/hire-vehicle">Hire a Bus</Link>
                    </li>
                  </ul>
                </li>

                <li className="notify">
                  <button
                    id="sub-active2"
                    className={`${
                      isMenuActive2 === 0 ? "active" : "drop-down-option"
                    }`}
                    // onClick={toggleMenu3}
                    // onClick={() => activeMenu(0)}
                  >
                    Do Freely
                    <img
                      id="sub-active-icon2"
                      src={down}
                      alt=""
                      className="ml-1"
                    />{" "}
                  </button>
                  <ul className="submenu" id="sub-menu2">
                    <li style={{ marginBottom: "10px" }}>
                      <Link to="/paybills">Bills Payment</Link>
                    </li>
                    <li>
                      <Link to="/enterprise">Enterprise Partner</Link>
                    </li>
                  </ul>
                </li>
                <li className="notify" style={{ marginLeft: "10px" }}>
                  <Link
                    to="/route-prices"
                    className="suggest-link drop-down-option"
                    exact={true}
                    activeClassName="active"
                  >
                    Check Route Price
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/entry" className="blue-btn-nav">
                    Sign In / Sign Up
                  </Link>
                </li>
              </ul>
            ) : (
              <ul className="menu-links ml-auto justify-content-end align-items-center">
                <li className="notify" style={{ marginLeft: "10px" }}>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://ghana.gigm.com/"
                    style={{ position: "relative", color: "black" }}
                  >
                    <img
                      src={newTag}
                      alt="nw-tag"
                      width="35"
                      height="35"
                      className="blink_me"
                      loading="lazy"
                      style={{
                        position: "absolute",
                        top: "-20px",
                        left: "30%",
                      }}
                    />
                    Ghana Booking
                  </a>
                </li>
                <li className="notify">
                  <button
                    id="sub-active"
                    // className="drop-down-option"
                    className={`${
                      isMenuActive === 0 ? "active" : "drop-down-option"
                    }`}
                    // onClick={toggleMenu2}
                  >
                    Move Freely
                    <img
                      id="sub-active-icon"
                      src={down}
                      alt=""
                      className="ml-1"
                    />{" "}
                  </button>
                  <ul className="submenu" id="sub-menu">
                    <li style={{ marginBottom: "10px" }}>
                      <Link to="/Pickupservice">Pick up Service</Link>
                    </li>
                    <li>
                      <Link to="/hire-vehicle">Hire a Bus</Link>
                    </li>
                  </ul>
                </li>

                <li className="notify">
                  <button
                    id="sub-active2"
                    // className="drop-down-option"
                    className={`${
                      isMenuActive2 === 0 ? "active" : "drop-down-option"
                    }`}
                    // onClick={toggleMenu3}
                  >
                    Do Freely
                    <img
                      id="sub-active-icon2"
                      src={down}
                      alt=""
                      className="ml-1"
                    />{" "}
                  </button>
                  <ul className="submenu" id="sub-menu2">
                    <li style={{ marginBottom: "10px" }}>
                      <Link to="/paybills">Bills Payment</Link>
                    </li>
                    <li>
                      <Link to="/enterprise">Enterprise Partner</Link>
                    </li>
                  </ul>
                </li>
                <li className="notify" style={{ marginLeft: "10px" }}>
                  <Link
                    to="/route-prices"
                    className="suggest-link drop-down-option"
                    exact={true}
                    activeClassName="active"
                  >
                    Check Route Price
                  </Link>
                </li>

                <li className="notify">
                  <button
                    id="sub-active3"
                    // className="drop-down-option"
                    className={`${
                      isMenuActive3 === 0 ? "active" : "drop-down-option"
                    }`}
                    // onClick={toggleMenu4}
                  >
                    <div className="avatar-icon">
                      {user?.Image === null || user?.Image === "" ? (
                        <img src={Avatar} alt="" className="rounded-circle" />
                      ) : (
                        <img
                          src={user?.Image}
                          alt=""
                          className="rounded-circle"
                        />
                      )}
                    </div>
                    <img
                      id="sub-active-icon3"
                      src={down}
                      alt=""
                      className="ml-1"
                    />{" "}
                  </button>
                  <ul className="submenu" id="sub-menu3">
                    <li style={{ marginBottom: "10px" }}>
                      <img src={account} alt="" />{" "}
                      <Link to="/setting">My Account</Link>
                    </li>
                    <li onClick={logOut}>
                      <i className="fa fa-sign-out"></i> Logout
                    </li>
                  </ul>
                </li>
              </ul>
            )}
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Navbar;
